import { PRICE_MARKUP_GROUP_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetPriceMarkupGroupList(listType){
    const api = `${PRICE_MARKUP_GROUP_API}?listType=${listType}`;
    return axiosHttp.get(api);
}
